export class UserResponse {
  constructor(
    public id: number,
    public first_name: string,
    public last_name: string,
    public email: string,
    public permissions: any,
    public roles: any,
    public unsecured_before_at: number,
    public unsecured_enabled: boolean,
    public status: string,
    public otp: boolean,
    public logo: string | null,
    public user_has_payment_methods: boolean,
    public affiliates?: any,
    public referral_link?: string
  ) {}

  /**
   * Processing from json
   */
  public static fromJson(json: any) {
    return new UserResponse(
      json.data.id,
      json.data.first_name,
      json.data.last_name,
      json.data.email,
      json.data.permissions,
      json.data.roles,
      json.data.unsecured_before_at,
      json.data.unsecured_enabled,
      json.data.status,
      json.data.otp,
      json.data.logo,
      json.data.user_has_payment_methods,
      json.data.affiliates,
      json.data.referral_link
    );
  }
}
